import { render, staticRenderFns } from "./LiveChatExpandBar.vue?vue&type=template&id=47c82cc2"
import script from "./LiveChatExpandBar.vue?vue&type=script&lang=js"
export * from "./LiveChatExpandBar.vue?vue&type=script&lang=js"
import style0 from "./LiveChatExpandBar.vue?vue&type=style&index=0&id=47c82cc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports